const projects = [
  {
    title: "QRescue – Emergency QR System",
    description:
      "A React-based application that generates emergency QR stickers for helmets, allowing first responders to access vital health data instantly.",
    tech: ["React", "Bootstrap", "Framer Motion", "Node.js"],
    link: "https://www.qrescue.gr",
  },
  {
    title: "Mads - Electric Scooters",
    description:
      "A web application for buying electric scooters, featuring a user-friendly interface and a robust backend for managing orders and inventory.",
    tech: ["WordPress", "WooCommerce", "PHP", "MySQL"],
    link: "https://mads.gr"
  },
  {
    title: "Internal Web App for Order Management",
    description:
      "Developed a custom web-based platform in React + Express for handling internal order requests with real-time tracking and status updates.",
    tech: ["React", "Node.js", "Express", "MongoDB"],
    link: "#",
  },
  {
    title: "GreekHumans",
    description:
      "Maintenance and development of a web application for the GreekHumans community, focusing on user engagement and content management.",
    tech: ["WordPress", "PHP", "MySQL"],
    link: "https://greekhumans.com",
  },
  {
    title: "NutritionGoals",
    description:
      "A nutrition and dietetics platform helping users set and track their dietary goals, with personalized meal plans and professional guidance.",
    tech: ["WordPress", "PHP", "MySQL"],
    link: "https://nutritiongoals.gr",
  },
  {
    title: "Recreating the Past",
    description:
      "A public history academic website publishing documented historical texts, news, and resources on Greek and military history, with a focus on Thessaloniki.",
    tech: ["WordPress", "PHP", "MySQL"],
    link: "https://recreatingthepast.gr",
  },
  {
    title: "Tennisstars Thessaloniki",
    description:
      "A modern website for a tennis club in Thessaloniki, showcasing programs for all ages, facilities, and an easy contact system for booking training sessions.",
    tech: ["WordPress", "PHP", "MySQL"],
    link: "https://tennisstars.gr",
  },
];

export default projects;
